import { useFormContext } from "react-hook-form";

import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
} from "@components";

import {
  SERVICE_HISTORY,
  ServiceHistoryFormDataType,
} from "@validations/HRM/employee/sevicesValidation";

export const ServiceHistoryForm = ({
  isProfileDisabled,
}: {
  isProfileDisabled: boolean;
}) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<ServiceHistoryFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <InputTextRow
        register={{ ...register(SERVICE_HISTORY.POSITION) }}
        label="EMPLOYEE.SERVICES_INFO.FORM.SERVICE_HISTORY_INFO.POSITION"
        error={errors}
        disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.SERVICE_HISTORY_INFO.ACC_SERVICE_DATE"
        control={control}
        register={{ ...register(SERVICE_HISTORY.ACC_SERVICE_DATE) }}
        errors={errors}
        name={SERVICE_HISTORY.ACC_SERVICE_DATE}
        required
        disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.SERVICE_HISTORY_INFO.GAZETTED_DATE"
        control={control}
        register={{ ...register(SERVICE_HISTORY.GAZETTED_DATE) }}
        errors={errors}
        name={SERVICE_HISTORY.GAZETTED_DATE}
        disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.SERVICE_HISTORY_INFO.CONFIRMATION_DATE"
        control={control}
        register={{ ...register(SERVICE_HISTORY.CONFIRMED_DATE) }}
        errors={errors}
        name={SERVICE_HISTORY.CONFIRMED_DATE}
        disabled={isProfileDisabled}
      />
      <InputDateControllerRow
        label="EMPLOYEE.SERVICES_INFO.FORM.SERVICE_HISTORY_INFO.SENIORITY_DATE"
        control={control}
        register={{ ...register(SERVICE_HISTORY.SENIORITY_DATE) }}
        errors={errors}
        name={SERVICE_HISTORY.SENIORITY_DATE}
        disabled={isProfileDisabled}
      />
      <MultiFileRow
        name="document"
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        disabled={isProfileDisabled}
      />
    </div>
  );
};
